export const BASE_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_ANALYTICS_MEASURMENTID = 'G-X3F9QVR4FB';
export const HOME_TRAGET = process.env.REACT_APP_FARM_HOME_TARGET;
